import * as action from "./actions";

export const getUsers = id => {
  return {
    type: action.GET_USERS,
    payload: id
  };
};

export const setUsers = users => {
  return {
    type: action.SET_USERS,
    payload: users
  };
};

const ACTION_HANDLERS = {
  [action.GET_USERS]: (state, action) => {
    return { ...state };
  },
  [action.SET_USERS]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
